<div style="text-align: center;">
    <h3>Votre demande de séance est enregistrée</h3>
    <p>Vous recevrez une mail de confirmation, dès que votre praticien l'aura validée.</p>
    <p>A bientôt</p>
</div>